import {
  AfterViewInit,
  Directive,
  Inject,
} from 'ng-metadata/core';

@Directive({
  selector: '[gw-auto-focus]',
})
export class AutoFocusDirective implements AfterViewInit {

  constructor(
    @Inject('$element') private $element: ng.IRootElementService,
    @Inject('$timeout') private $timeout: ng.ITimeoutService,
  ) {}

  ngAfterViewInit() {
    this.$timeout(
      () => {
        this.$element[0].focus();
      });
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/auto-focus.directive.ts